export default "__VITE_ASSET__DcoaTHIT__"